import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VersionCheckService implements OnDestroy {
  private currentVersion: string | null = null;
  private pollSubscription: Subscription | null = null;

  updateAvailable$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) {}

  startChecking(intervalMs = 1 * 30 * 1000): void {
    this.fetchVersion().subscribe(version => {
      this.currentVersion = version;
    });

    this.pollSubscription = interval(intervalMs).pipe(
      switchMap(() => this.fetchVersion())
    ).subscribe(version => {
      if (this.currentVersion && version && version !== this.currentVersion) {
        this.updateAvailable$.next(true);
      }
    });
  }

  private fetchVersion() {
    return this.http
      .get<{ version: string }>(`/version.json?cb=${Date.now()}`)
      .pipe(
        map(res => res?.version ?? null),
        catchError(() => of(null))
      );
  }

  ngOnDestroy(): void {
    this.pollSubscription?.unsubscribe();
  }
}
